module.exports = __webpack_public_path__ + "img/credit.27125c80.png";